// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprConfigure extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.configure";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprConfigure {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Indstillinger",
                "de": "Einstellungen",
                "en": "Settings",
                "es": "Configuración",
                "fr": "Réglages",
                "it": "Impostazioni",
                "nl": "Instellingen",
                "pt": "Definições",
                "pt-BR": "Configuração",
                "ru": "Параметры",
                "ca": "Configuració",
                "eu": "Ezarpenak",
                "gl": "Configuración",
                "fi": "Asetukset",
                "hi": "सेटिंग्स",
                "hu": "Beállítások",
                "no": "Innstillinger",
                "pl": "Ustawienia",
                "ro": "Configurație",
                "cs": "Nastavení",
                "sk": "Nastavenia",
                "sv": "Inställningar"
            }
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
